import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  StyleSheet,
  Text,
  TextInput,
  View,
} from './components/base_components';
import BreadcrumbPath from './components/breadcrumb_path';
import StandardBoxList from './components/standard_box_list';
import StandardScreen from './components/standard_screen';
import TextButton from './components/buttons/text_button';

import MediaStore from './stores/media_store';
import UserStore from './stores/user_store';
import VolumeStore from './stores/volume_store';

const styles = StyleSheet.create({
  createFolderScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  dialog: {
    marginLeft: '2rem',
    marginBottom: '2rem',
    flexDirection: 'column',
  },
  text: {
    marginTop: '1em',
    fontSize: '1.5em',
  },
  input: {
    alignSelf: 'stretch',
    maxWidth: '40rem',
    marginTop: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: '#555',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#f5f5f5',
  },
  button: {
    marginTop: '1rem',
    alignSelf: 'flex-start',
  },
});

export default function VolumeUploadScreen(props) {
  const params = useParams();
  const navigate = useNavigate();
  const org = UserStore.useOrg();
  const volume_id = parseInt(params.volume_id ?? '0', 10) || 0;
  const volume = VolumeStore.useVolume(org?.org_id, volume_id);
  const path = '/' + (params['*'] ?? '');
  const [new_dir, setNewDir] = React.useState('');

  React.useEffect(() => {
    VolumeStore.fetch(org?.org_id);
  }, [org?.org_id]);

  function _onCreatePress() {
    MediaStore.createDir({ volume_id, path, new_dir });
    navigate(`/volume/${volume_id}${path}${new_dir}/`);
  }

  return (
    <View style={styles.createFolderScreen}>
      <StandardScreen>
        <BreadcrumbPath
          volumeName={volume?.volume_name}
          prefix={`/volume/${volume_id}/`}
          path={path}
          extra='Create Folder'
        />
        <StandardBoxList title='New Folder'>
          <View style={styles.dialog}>
            <Text style={styles.text}>Create a new folder.</Text>
            <TextInput
              style={styles.input}
              placeholder='New Folder Name'
              value={new_dir}
              onChangeText={setNewDir}
            />
            <TextButton
              style={styles.button}
              text='Create Folder'
              onPress={_onCreatePress}
            />
          </View>
        </StandardBoxList>
      </StandardScreen>
    </View>
  );
}
